import {
  Box,
  Paper,
  Typography,
  Grid,
  Chip,
  LinearProgress,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import {
  EventAvailableRounded,
  FiberManualRecordRounded,
  AccessTimeRounded,
  AlarmRounded,
  FreeBreakfastRounded,
  CallRounded,
  EditRounded,
} from "@mui/icons-material";
import { palette, theme  as colorTheme} from "../../../../Convoze.theme";



const colors = {
  // bg: "#0b0b0f",
  bg:colorTheme('palette', 'night').value,
  // surface: "#0f1014",
  surface:colorTheme('palette', 'night').value,
  // card: "#111217",
  card :colorTheme('palette', 'night').value,
  // border: "#1f1f23",
  border :colorTheme('palette', 'night').value,
  text: "#e5e7eb",
  // subtext: "#9aa0a6",
  subtext:colorTheme('palette', 'night').value,
  // purple: "#7c3aed",
  purple :colorTheme('palette', 'primary').value,
  // purpleLight: "#a78bfa",
  purpleLight:colorTheme('palette', 'primary').value,
  // green: "#10b981",
  green:colorTheme('palette', 'positive').value,
  // amber: "#fbbf24",
  amber :colorTheme('palette', 'neutral').value,
};

const Progress = styled(LinearProgress)({
  height: 8,
  borderRadius: 10,
  backgroundColor: "#DAD6D6",
  "& .MuiLinearProgress-bar": {
    borderRadius: 10,
    // background: `linear-gradient(90deg, #6366F1 0%, #9495dcff 50%, #a78bfa 100%)`,
    background:colorTheme('palette', 'primary').value,
  },
});

function MetricTile({
  icon,
  value,
  label,
  valuColor,
  gradient 
}) {
  return (
    <Paper
      elevation={0}
      sx={{
        backgroundImage: gradient,
        borderRadius: 2,
        p: { xs: 1.5, sm: 2 },
        // minHeight: 70,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
      }}
    >
      <Box sx={{ display: "grid", placeItems: "center", gap: 0.5 }}>
        <Box sx={{ display: "inline-flex", alignItems: "center", gap: 1 }}>
          {icon}
          <Typography
            variant="h6"
            sx={{
              //  color: "#6366F1",
              color:colorTheme('palette', 'primary').value,
                fontWeight: 700, lineHeight: "1.75rem",fontSize:"1.125rem" }}
          >
            {value}
          </Typography>
        </Box>
        <Typography variant="caption" sx={{ fontWeight: 600,lineHeight: "0.75rem" ,color:"hsl(240 3.8% 46.1%)" }}>
          {label}
        </Typography>
      </Box>
    </Paper>
  );
}

export default function DailyMissionCard({
  shiftHours = "8h",
  breakLeft = "45m",
  toGoal = 23,
  progress = 82,
  hoursLeft = "5h left",
}) {
  return (
    <Paper
      elevation={0}
      sx={{
        border: `0.5px solid ${colorTheme('palette', 'primaryBg').value}`,
        borderRadius: 2,
        p: { xs: 1.5, sm: 2 },
      }}
    >
      {/* Header */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1.25,
          mb: { xs: 1.5, sm: 2 },
        }}
      >
        <EventAvailableRounded sx={{ 
          // color: "#6366F1"
          color:colorTheme('palette', 'primary').value,
           }} />
        <Typography
          variant="subtitle1"
          sx={{
            fontWeight: 600,
            // background: `linear-gradient(90deg, #6366F1 0%, #9495dcff 50%, #a78bfa 100%)`,
            background:colorTheme('palette', 'primary').value,
            lineHeight: 1,
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
            backgroundClip: "text",
            color: "transparent",
          }}
        >
          Daily Mission
        </Typography>
        <FiberManualRecordRounded sx={{ fontSize: 14, color: colors.purple }} />
        <Chip
          size="small"
          icon={<AccessTimeRounded sx={{ fontSize: 16 }} />}
          label={hoursLeft}
          sx={{
            height: 24,
            // bgcolor: "rgba(251,191,36,0.14)",
            bgcolor:colorTheme('palette', 'neutral').value,
            color: colors.amber,
            border: `1px solid ${colorTheme('palette', 'neutral').value}`,
            "& .MuiChip-icon": { color: colors.amber, ml: 0.5 },
            fontWeight: 700,
          }}
        />
      </Box>

      {/* Tiles */}
      <Grid container spacing={2} sx={{ mb: { xs: 1.5, sm: 2 } }}>
        <Grid item xs={12} md={4}>
          <MetricTile
            icon={<AlarmRounded sx={{
              //  color: "#6366F1" 
              color:colorTheme('palette', 'primary').value,
              }} />}
            value={shiftHours}
            label="Shift Hours"
            gradient="linear-gradient(90deg, rgba(160, 109, 246, 0.22) 0%, rgba(197, 168, 248, 0.06) 100%)"
            // valuColor={"#6366F1"}
            valuColor={colorTheme('palette', 'primary').value}
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <MetricTile
            icon={<FreeBreakfastRounded sx={{ color: colors.green }} />}
            value={breakLeft}
            label="Break Left"
            // gradient="linear-gradient(90deg, rgba(16,185,129,0.2) 0%, rgba(16,185,129,0.06) 100%)"
            gradient={colorTheme('palette', 'positive').value}
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <MetricTile
            icon={<CallRounded sx={{ color: colors.amber }} />}
            value={toGoal}
            label="To Goal"
            // gradient="linear-gradient(90deg, rgba(251,191,36,0.18) 0%, rgba(251,191,36,0.05) 100%)"
            gradient={colorTheme('palette', 'neutral').value}
          />
        </Grid>
      </Grid>

      {/* Progress bar block */}
      <Paper
        elevation={0}
        sx={
          {
            //   border: `0.5px solid #D2D2D2`,
            //   borderRadius: 1.5,
            //   p: { xs: 1, sm: 1.25 },
          }
        }
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            mb: 0.75,
          }}
        >
          <Typography variant="caption" sx={{ fontWeight: 700 }}>
            Daily Progress
          </Typography>
          <Box sx={{ display: "inline-flex", alignItems: "center", gap: 0.5 }}>
            <Typography
              variant="caption"
              sx={{
                //  color: "#6366F1",
                color:colorTheme('palette', 'primary').value,
                  fontWeight: 700 }}
            >
              {progress}%
            </Typography>
            <EditRounded sx={{ fontSize: 16,
              //  color: "#6366F1" 
              color:colorTheme('palette', 'primary').value,
               }} />
          </Box>
        </Box>
        <Progress
          value={progress}
          variant="determinate"
          aria-label="Daily progress"
        />
      </Paper>
    </Paper>
  );
}
